const Main = ({children}) => {
	return (
		<div className="xl:ml-32 mt-4 xl:mt-0 xl:w-2/3">
			{children}
		</div>
	);
}
 
export default Main;